export const SHIFT_SUMMARY_TITLE_ID = 'shift-summary-title'
export const SHIFT_SUMMARY_EVENTS_PAGE_SIZE = 100
